import { AController } from "@eagerlogic/react-mvc";
import { ApiException } from "rpc/rpc";
import { AuthRpc } from "rpc/auth/AuthRpc";
import { LoginModel } from "../model/LoginModel";

export class LoginController extends AController<LoginModel> {

    protected createInitialModel(): LoginModel {
        return new LoginModel();
    }

    public onLoginClicked(email: string, password: string) {
        this.model.email = email;
        this.model.password = password;
        this.model.error = null;
        this.render(this.model);

        AuthRpc.login(email, password).then(() => {
            window.location.href = "/index.rsc";
        }).catch((ex: ApiException) => {
            this.model.error = ex.message != null ? ex.message : "Invalid email or password!";
            this.render(this.model);
        });
    }

    public onCancelClicked() {
        window.location.href = "/index.jsp";
    }

}
